import { fetchConfigOfCreatePOA } from "@/api/POA";
import { reactive } from "vue";

interface CnfSetting {
  setting_id?: string;
  setting_value?: boolean | string | number;
}

const parseBoolean = (value: CnfSetting["setting_value"]) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  return value?.toLowerCase() === "true";
};

export const FEATURE_FLAGS = reactive({
  ai: false,
  tencentSurvey: false,
  loaded: false,
});

let initialization: Promise<void> | undefined;

export const initializeFeatureFlags = () => {
  if (initialization) return initialization;

  initialization = fetchConfigOfCreatePOA()
    .then((response: any) => {
      const settings: CnfSetting[] = Array.isArray(response)
        ? response
        : response?.value || response?.data || [];
      const getSetting = (settingId: string) =>
        settings.find((item) => item.setting_id === settingId)?.setting_value;

      FEATURE_FLAGS.ai = parseBoolean(getSetting("enable_ai"));
      FEATURE_FLAGS.tencentSurvey = parseBoolean(
        getSetting("enable_tencent_survey"),
      );
    })
    .catch((error) => {
      console.error("Failed to load feature flags", error);
    })
    .finally(() => {
      FEATURE_FLAGS.loaded = true;
    });

  return initialization;
};
